import React from "react";
//import "../styles/Team.css"; // optional external styling if you want to customize later

const teamMembers = [
  {
    name: "Mr. Avinash Nanaware",
    role: "Director",
    image: "team.jpg",
  },
   {
    name: "Mr. Sidheshwar. R. Yavalkar",
    role: "Director",
    image: "team1.jpg",
  },
  {
    name: "Mr. Santosh Rokade",
    role: "Operations Manager",
    subrole: "community engagement & camp coordination",
    image: "team2.jpeg",
  },
];

const trustees = [
  {
    name: "Shri Somesh. R. Yavalkar",
    role: "Chairman",
    image: "trustee1.jpeg",
  },
];


const MedicalteamMembers = [
  {
    name: "Dr. Sanjay R. Shrivastava",
    role: "Medical Officer",
    image: "medical1.jpeg",
  },
  {
    name: "Dr. Abhishek S. Baravkar",
    role: "BTO",
    image: "medical2.jpeg",
  },
   {
    name: "Dr. Mangesh J. Khandave",
    role: "BTO",
    image: "medical3.jpeg",
  },
];

export default function Team() {
  return (
    <div className="team-page" style={{ background: "#f9f6f7", minHeight: "100vh" }}>
      {/* 🔴 Hero Section */}
      <section className="hero">
        <h2>
          Our Team & Trustees
        </h2>
        <p>
          Dedicated professionals and trustees working together to ensure safe
          and efficient blood services.
        </p>
      </section>

      {/* 🤝 Trustees */}
      <section className="container-team" style={{ maxWidth: 1200, margin: "3rem auto", padding: "0 1rem" }}>
        <h2 style={{ color: "#d32f2f", textAlign: "center" }}>Trustees</h2>
        <div
  className="grid"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "1.5rem",
    marginTop: "1.5rem",
  }}
>
  {trustees.map((person, index) => (
    <div
      key={index}
      style={{
        background: "white",
        borderRadius: "12px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        padding: "1rem",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        src={person.image}
        alt={person.name}
        style={{
          width: "180px",
          height: "220px",
          objectFit: "cover",
          borderRadius: "20px",
          marginBottom: "1rem",
        }}
      />
      <h4 style={{ margin: "0.5rem 0", color: "#d32f2f" }}>{person.name}</h4>
      <p style={{ margin: 0, color: "#555",fontWeight: "bold" }}>{person.role}</p>
    </div>
  ))}
</div>

      </section>

      
      {/* 👩‍⚕️ Team Members */}
      <section className="container-team" style={{ maxWidth: 1200, margin: "2rem auto", padding: "0 1rem" }}>
        <h2 style={{ color: "#d32f2f", textAlign: "center" }}>Director & Officers</h2>
        <div
          className="grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.5rem",
            marginTop: "1.5rem",
          }}
        >
          {teamMembers.map((member, index) => (
            <div
              key={index}
              style={{


                  background: "white",
                  borderRadius: "12px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  padding: "1rem",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
              }}
            >
              <img
                src={member.image}
                alt={member.name}
                style={{
          width: "180px",
          height: "220px",
          objectFit: "cover",
          borderRadius: "20px",
          marginBottom: "1rem",
                }}
              />
              <h4 style={{ margin: "0.5rem 0", color: "#d32f2f" }}>{member.name}</h4>
              <p style={{ margin: 0, color: "#555",fontWeight: "bold" }}>{member.role}</p>
              <small> {member.subrole}</small>
            </div>
          ))}
        </div>
      </section>

            {/* 👩‍⚕️ Medical Team Members */}
      <section className="container-team" style={{ maxWidth: 1200, margin: "2rem auto", padding: "0 1rem" }}>
        <h2 style={{ color: "#d32f2f", textAlign: "center" }}>Medical Team</h2>
        <div
          className="grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.5rem",
            marginTop: "1.5rem",
          }}
        >
          {MedicalteamMembers.map((member, index) => (
            <div
              key={index}
              style={{


                  background: "white",
                  borderRadius: "12px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  padding: "1rem",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
              }}
            >
              <img
                src={member.image}
                alt={member.name}
                style={{
          width: "180px",
          height: "220px",
          objectFit: "cover",
          borderRadius: "20px",
          marginBottom: "1rem",
                }}
              />
              <h4 style={{ margin: "0.5rem 0", color: "#d32f2f" }}>{member.name}</h4>
              <p style={{ margin: 0, color: "#555",fontWeight: "bold" }}>{member.role}</p>
              <small> {member.subrole}</small>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
